import { render, staticRenderFns } from "./sample-recollect-detail.vue?vue&type=template&id=16d5c27e&"
import script from "./sample-recollect-detail.vue?vue&type=script&lang=js&"
export * from "./sample-recollect-detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports